export class RetryTimeoutError extends Error {
  constructor(phase, operationId) {
    super(`Operation timed out during ${phase}`);
    this.name = "RetryTimeoutError";
    this.phase = phase;
    this.operationId = operationId;
    this.isTransient = false;
  }
}

export class RetryExhaustedError extends Error {
  constructor(phase, operationId, attempts, cause) {
    super(`Operation failed after ${attempts} attempt(s) during ${phase}`);
    this.name = "RetryExhaustedError";
    this.phase = phase;
    this.operationId = operationId;
    this.attempts = attempts;
    this.isTransient = true;
    this.cause = cause;
  }
}

export function normalizeRetryError(error, phase, operationId, attempt) {
  if (error instanceof RetryTimeoutError || error instanceof RetryExhaustedError) {
    return error;
  }

  const message = error instanceof Error ? error.message : "Operation failed";
  const wrapped = new Error(message, { cause: error });
  wrapped.name = error instanceof Error ? error.name : "Error";
  wrapped.phase = phase;
  wrapped.operationId = operationId;
  wrapped.attempt = attempt;
  wrapped.isTransient = Boolean(error?.isTransient);
  return wrapped;
}
